module.exports = __webpack_public_path__ + "img/firestick.92627a4e.svg";